'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'

import { FaStepForward, FaTimes } from 'react-icons/fa'
import { useAuth } from '../contexts/AuthContext'
import Modal from './Modal'

const ads = [
  // },
  // },
  // },
  // },
  // },
  // },
  // },
  // },
  // },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade1.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade2.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade3.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade4.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade5.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade6.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade7.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade8.webp',
    adType: 'image',
  },
  {
    adName: 'promptchan ad',
    adUrl: '/upgrade',
    adImage: '/assets/links/upgrade9.webp',
    adType: 'image',
  },
  // },
  // },
  {
    adName: 'upgrade video ad 1',
    adUrl: '/upgrade',
    adVideo: '/assets/links/upgradeVideo1.mp4',
    adType: 'video',
  },
  {
    adName: 'upgrade video ad',
    adUrl: '/upgrade',
    adVideo: '/assets/links/upgradeVideo2.mp4',
    adType: 'video',
  },
  {
    adName: 'upgrade video ad',
    adUrl: '/upgrade',
    adVideo: '/assets/links/upgradeVideo3.mp4',
    adType: 'video',
  },
  {
    adName: 'upgrade video ad',
    adUrl: '/upgrade',
    adVideo: '/assets/links/upgradeVideo4.mp4',
    adType: 'video',
  },
  {
    adName: 'upgrade video ad',
    adUrl: '/upgrade',
    adVideo: '/assets/links/upgradeVideo5.mp4',
    adType: 'video',
  },
]

const AdCard = ({ showSkipAds }) => {
  const { subscription } = useAuth()
  const router = useRouter()
  const [currentAd, setCurrentAd] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    const randomAd = ads[Math.floor(Math.random() * ads.length)]
    setCurrentAd(randomAd)
  }, [])

  const handleClose = () => {
    router.push('/upgrade')
  }

  return (
    <span className="relative group overflow-hidden rounded-md shadow-md bg-white w-60 transition-all duration-300 ease-in-out transform hover:scale-105 hover:-webkit-transform min-w-0">
      <Modal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title="Upgrade for No Ads 🔥"
        content="Upgrade now for the ultimate Ad free experience, with more Gems and AI features."
        confirmation="Upgrade"
        onConfirm={() => router.push('/upgrade')}
      />

      <a href={currentAd.adUrl} target="_blank" rel="noopener noreferrer">
        {subscription?.plan === 'Free' && currentAd.adType === 'image' && (
          <img
            src={currentAd.adImage}
            alt={currentAd.adName}
            className="object-cover object-center w-full h-240 rounded-md transition-opacity duration-500 ease-in-out opacity-100"
          />
        )}
        {subscription?.plan === 'Free' && currentAd.adType === 'video' && (
          <video
            src={currentAd.adVideo}
            autoPlay="autoplay"
            loop={true}
            muted={true}
            playsInline
            className="object-cover object-center w-full h-240 rounded-md transition-opacity duration-500 ease-in-out opacity-100"
          >
            Your browser does not support the video tag.
          </video>
        )}
      </a>
      <div className="absolute top-0 left-0 w-full p-2 flex justify-between items-center opacity-80">
        <button
          onClick={handleClose}
          className="text-xs bg-gray-200/75 px-2 py-1 rounded font-semibold"
        >
          Sponsored
        </button>
        <button
          onClick={handleClose}
          className="text-xs bg-gray-200/75 p-1 rounded-xl"
        >
          <FaTimes />
        </button>
      </div>
      {showSkipAds && (
        <button
          onClick={() => {
            setIsModalOpen(true)
          }}
          className="absolute bottom-2 right-2 text-black bg-gray-200/75 px-3 py-2 rounded flex items-center justify-center hover:scale-[1.03] transition-transform duration-100"
        >
          <p className="mr-2 ">Skip Ad</p>
          <FaStepForward className="text-xl" />
        </button>
      )}
    </span>
  )
}

export default AdCard
